import React from "react";
import classnames from "classnames";
import Rail from "web/react/components/rail/rail";
import LazyLoadImage from "web/react/components/lazy-load-image/lazy-load-image";
import styles from "./sale-landing-page-categories-rail.css";

interface CategoryItem {
    title: string;
    image_url: string;
    image_alt: string;
    url: string;
}

interface SaleLandingPageCategoryItemProps {
    item: CategoryItem;
}

export function SaleLandingPageCategoryItem({
    item,
}: SaleLandingPageCategoryItemProps): JSX.Element {
    return (
        <a className={classnames(styles.saleLandingPageCategoriesCategoryItem)} href={item.url}>
            <LazyLoadImage
                className={classnames(styles.saleLandingPageCategoriesCategoryImg)}
                src={item.image_url}
                alt={item.image_alt}
            />
            <span className={classnames(styles.saleLandingPageCategoriesCategoryLink)}>
                {item.title}
            </span>
        </a>
    );
}

interface SaleLandingPageCategoriesRailProps {
    items: CategoryItem[];
}

export function SaleLandingPageCategoriesRail({
    items,
}: SaleLandingPageCategoriesRailProps): JSX.Element {
    const buttonStyle = classnames(styles.scrollButton);
    const leftButtonStyle = classnames(buttonStyle, styles.left);
    const rightButtonStyle = classnames(buttonStyle, styles.right);

    return (
        <Rail
            className={styles.saleLandingPageCategoriesRail}
            analyticsLabel={"sale_page_category_rail"}
            title={""}
            leftButtonStyle={leftButtonStyle}
            rightButtonStyle={rightButtonStyle}
            buttonIcon={"square-chevron"}
        >
            {items.map((item) => {
                return <SaleLandingPageCategoryItem key={item.url} item={item} />;
            })}
        </Rail>
    );
}

export default SaleLandingPageCategoriesRail;
